import * as XLSX from 'xlsx';
import {
  mapUserToExportRow,
  buildExportFilename,
  validateExportRecordCount
} from './userExportUtils';

export const exportUsersToExcel = (users = [], filters = {}) => {
  if (!Array.isArray(users) || users.length === 0) {
    return;
  }

  validateExportRecordCount(users.length);

  const excelData = users.map((user) => mapUserToExportRow(user));
  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');
  XLSX.writeFile(workbook, buildExportFilename(filters));
};
